module.exports = {"header":{"portalName":"uMotif 门户网站"},"message":{"error":{"default":"抱歉，发生了一个错误。","invalidCode":"输入的代码无效。请再试一次。"}}}